import angular from 'angular';
import loader from './LoaderManager';

export default angular.module('cms.loader.directive', [loader])
    .component('loader', {
    template: require('./loader.html'),
    controller: function (LoaderManager) {
            this.active = function() {
                return LoaderManager.getActive('global');
            }
        }
    }).name;


// WEBPACK FOOTER //
// ./src/cmsCore/Loader/LoaderDirective.js